export default {
  sendData: 'sendData',
  startUnit: 'startUnit',
  completeOperation: 'completeOperation',
};
